import React from "react";
import PropTypes from "prop-types";
import Assignment from "@material-ui/icons/Assignment";
import { useTranslation } from "react-i18next";
import { useFeedback } from "../ConsultantFeedback/FeedbackContext";
import FloatingToolbarItem from "./FloatingToolbarItem";

export default function FeedbackToolbarItem({ _mobile, _position, ...rest }) {
  const { activeTopicsCount, setModalOpen } = useFeedback();
  const { t } = useTranslation();

  return (
    <FloatingToolbarItem
      icon={<Assignment fontSize="inherit" />}
      badge={activeTopicsCount}
      tooltip={t("feedback.title")}
      mobileLabel={t("feedback.title")}
      onClick={() => setModalOpen(true)}
      _mobile={_mobile}
      _position={_position}
      {...rest}
    />
  );
}

FeedbackToolbarItem.propTypes = {
  _mobile: PropTypes.bool,
  _position: PropTypes.string,
};
